// extracted by mini-css-extract-plugin
export default {"root":"UI16Q5TpKvxqS4ihcxTs","clickable":"a_L8dYPGyVot2HEeRMRP","static":"lNrtP3vYGmAmWFFv1gfS","label":"WahnAEidH5lVk_DDsFKY"};